// extracted by mini-css-extract-plugin
export default {"element":"SocialIcons_element__50aqw"};